export default __webpack_public_path__ + "static/media/宠帮运勋章.6fd7d296.png";